<zf-sidebar [serialNumber]="serialNumber()"></zf-sidebar>

<zf-loading-indicator *ngIf="!deployment()"></zf-loading-indicator>

<div class="content">
    <div *ngIf="!!deployment()" class="deployment-stats">
        <div class="grid-item full l-thin align-center">
            <div class="header">
                <h3>Instance</h3>
                <div class="buttons tabs">
                    <div class="action">
                        <button (click)="refresh()">Refresh</button>
                    </div>
                </div>
            </div>

            <div class="information">
                <div class="row flex-auto">
                    <div class="text">
                        <label>Licensed as</label>
                        <div>{{ deployment()?.information?.deploymentType | deploymentType
                            }}</div>
                    </div>
                    <div class="text">
                        <label>Deployed on</label>
                        <div>{{ deployment()?.information?.created | date }}</div>
                    </div>
                </div>
            </div>
        </div>
        <div class="grid-item medium">
            <div class="header">
                <h3>Information</h3>
            </div>
            <div class="information">
                <div class="row">
                    <div class="text">
                        <label>Serial Number</label>
                        <div><a class="external" rel="noopener noreferrer" target="_blank"
                                [href]="deployment().information.url.endsWith('.') ? deployment().information.url.stripLast() : deployment().information.url">
                                {{ deployment().serialNumber }}</a></div>
                    </div>
                    <div class="text">
                        <label>Description</label>
                        <div>{{ deployment()?.description !== '' ? deployment().description : '-'
                            }}</div>
                    </div>
                </div>
                <div class="row">
                    <div class="text">
                        <label>Region</label>
                        <div>{{ displayRegion() }}</div>
                    </div>
                    <div class="text">
                        <label>External IP</label>
                        <div>{{ deployment()?.information?.externalIP || '-' }}</div>
                    </div>
                </div>
                <div class="row">
                    <div class="text">
                        <label>Super FQDN</label>
                        <div (click)="copyToClipboard($event, deployment().information.url);"
                            style="text-decoration: underline; cursor: pointer;" title="Click to copy to clipboard">{{
                            deployment().information.url | url }}
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="text">
                        <label>Worker FQDN</label>
                        <div (click)="copyToClipboard($event, deployment().information.workersUrl);"
                            style="text-decoration: underline; cursor: pointer;" title="Click to copy to clipboard">{{
                            deployment().information.workersUrl | url }}
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="grid-item medium">
            <div class="header">
                <h3>Entitlement</h3>
            </div>
            <div class="information">
                <div class="row flex-auto">
                    <div class="text">
                        <label>Compute</label>
                        <div>{{ deployment()?.entitlement?.compute | SKU:'compute' }}</div>
                    </div>
                    <div class="text">
                        <div>This provides the computational resources for event
                            ingestion, analytics searches, rule evaluation and machine learning jobs.
                        </div>
                    </div>
                </div>
                <div class="row flex-auto">
                    <div class="text">
                        <label>Online Storage</label>
                        <div>{{ deployment()?.entitlement?.onlineStorage | SKU:'online'
                            }}</div>
                    </div>
                    <div class="text">
                        <div>This provides hot, short term, storage.
                        </div>
                    </div>
                </div>
                <div class="row flex-auto">
                    <div class="text">
                        <label>Archive Storage</label>
                        <div>{{ deployment()?.entitlement?.archiveStorage | SKU:'archive'
                            }}</div>
                    </div>
                    <div class="text">
                        <div>This provides cold, long term, instantly accessible storage.</div>
                    </div>
                </div>
            </div>
        </div>
        <div class="grid-block small">
            <div class="grid-item small m-thin">
                <div class="information">
                    <div class="row align-center no-margin">
                        <div class="version-icon">
                            <i class="icon fontello-icon icon-shield-checked"
                                [ngClass]="isUpdatePossible(deployment()) ? 'up-to-date' : 'out-of-date'"></i>
                        </div>
                        <div class="text">
                            <ngContainer [ngSwitch]="isUpdatePossible(deployment())">
                                <div *ngSwitchCase="true">You can make changes</div>
                                <div *ngSwitchDefault>Changes are currently propagating</div>
                            </ngContainer>
                            <div>Status: {{ deployment()?.information?.status | pascalToHuman }}</div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="grid-item small thin">
                <div class="header">
                    <h3>Update</h3>
                    <div *ngIf="!loadingUpdate() && hasUpdate()" class="buttons tabs">
                        <div class="action" style="text-align: right;">
                            <button (click)="schedule()" class="btn">{{ hasScheduledUpdate() ? 'Change' :
                                'Schedule'}}</button>
                        </div>
                    </div>
                </div>
                <div *ngIf="!loadingUpdate()" class="information">
                    <div class="row align-center">
                        <div class="text">
                            <div>FortiSIEM Cloud regularly releases updates to bring new features, and to improve
                                stability and
                                security of your deployment().
                            </div>
                        </div>
                    </div>
                    <div *ngIf="!hasUpdate()" class="row align-center">
                        <div class="text">
                            <div>Your FortiSIEM cloud instance is up to date</div>
                        </div>
                    </div>
                    <div class="row no-margin flex-auto small">
                        <div class="text">
                            <label>Version</label>

                        </div>
                        <div *ngIf="!hasUpdate()" class="text">
                            {{ deployment()?.information?.version
                            }}
                        </div>
                        <div *ngIf="hasUpdate()" class="text">
                            {{ versionUpdate().currentVersion
                            }} <span *ngIf="hasUpdate()"> -> {{ versionUpdate().newVersion
                                }}&nbsp;&nbsp;&nbsp;&nbsp;<a *ngIf="versionUpdate().docsLink" target="_blank"
                                    [href]="versionUpdate().docsLink">what's new</a></span>
                        </div>
                    </div>
                    <div *ngIf="hasScheduledUpdate()" class="row no-margin flex-auto small">
                        <div class="text">
                            <label>When</label>
                        </div>
                        <div class="text">
                            {{
                            upgrade().scheduledLocal
                            | upgradeDate:'day' }} at {{ upgrade().scheduledLocal | upgradeDate:'hour'}} in
                            UTC{{upgrade().scheduledLocal | upgradeDate:'offset'}}</div>
                    </div>
                    <div *ngIf="hasScheduledUpdate() && upgrade().scheduledBy" class="row no-margin flex-auto small">
                        <div class="text">
                            <label>Set By</label>
                        </div>
                        <div class="text">
                            {{ upgrade().scheduledBy }}</div>
                    </div>
                </div>
                <div *ngIf="loadingUpdate()" class="loading-container">
                    <div class="loader"></div>
                </div>
            </div>

        </div>
        <div class="grid-item medium-plus thin">
            <div class="header">
                <h3>Network</h3>
                <div class="buttons tabs">
                    <div class="action" style="text-align: right;">
                        <button [disabled]="!isUpdatePossible(deployment())" (click)="editState.set('network'); edit()"
                            class="btn">Edit</button>
                    </div>
                </div>
            </div>

            <div class="information">
                <div class="row">
                    <div class="text">
                        <label>Allowed IPV4</label>
                        <div>{{deployment()?.information?.ipV4Cidr | csv }}</div>
                    </div>
                    <div class="text">
                        <label>Allowed IPV6</label>
                        <div>{{deployment()?.information?.ipV6Cidr | csv }}</div>
                    </div>
                </div>
            </div>
        </div>
        <div class="grid-item small-plus thin">
            <div class="header">
                <h3>Notifications</h3>
                <div class="buttons tabs">
                    <div class="action" style="text-align: right;">
                        <button [disabled]="!isUpdatePossible(deployment())" (click)="editState.set('notifications'); edit()"
                            class="btn">Edit</button>
                    </div>
                </div>
            </div>

            <div class="information">
                <div class="row">
                    <div class="text">
                        <label>Primary Contact</label>
                        <div>{{ deployment()?.information?.deploymentEmail }}</div>
                    </div>
                </div>
                <div class="row">
                    <div class="text">
                        <label>Additional Contacts</label>
                        <div>{{ deployment()?.information?.additionalContacts || '-' | csv }}</div>
                    </div>
                </div>
            </div>
        </div>
        <div class="grid-item small thin">
            <div class="header">
                <h3>Alternate Domain</h3>
                <div class="buttons tabs">
                    <div class="action" style="text-align: right;">
                        <button [disabled]="!isUpdatePossible(deployment())" (click)="editState.set('domain'); edit()"
                            class="btn">Edit</button>
                    </div>
                </div>
            </div>

            <div class="information">
                <div class="row">
                    <div class="text">
                        <div>{{
                            deployment().information.alternateDomain || '-' | url }}</div>
                    </div>
                </div>
            </div>
        </div>


        <div class="grid-item full" id="events-per-second">
            <div class="header">
                <h3>Events Per Second</h3>
                <div class="buttons tabs">
                    <button class="highlight" (click)="eventsTime.set('hour');refreshMetrics();"
                        [ngClass]="{'active': eventsTime() === 'hour'}">
                        Hour </button>
                    <button class="highlight" (click)="eventsTime.set('day');refreshMetrics();"
                        [ngClass]="{'active': eventsTime() === 'day'}"> Day
                    </button>
                    <button class="highlight" (click)="eventsTime.set('week');refreshMetrics();"
                        [ngClass]="{'active': eventsTime() === 'week'}">
                        Week </button>
                    <button class="highlight" (click)="eventsTime.set('month');refreshMetrics();"
                        [ngClass]="{'active': eventsTime() === 'month'}">
                        Month </button>
                </div>
            </div>

            <div #chartContainer class="chart" *ngIf="eventsPerSecInfo()?.length > 0">
                <ngx-charts-line-chart [view]="[(chartContainer.offsetWidth - 5), (chartContainer.offsetHeight - 33)]"
                    [autoScale]="false" [animations]="false" [roundDomains]="false" [xAxis]="true" [yAxis]="true"
                    [legend]="true" [legendPosition]="LegendPosition.Below" [legendTitle]="''"
                    [referenceLines]="refLines()" [showRefLines]="true" [showRefLabels]="true"
                    [results]="eventsPerSecInfo()">
                    <ng-template #tooltipTemplate let-model="model">
                        <div>{{model.series}}: {{model.value | number: '1.0-0'}}</div>
                        <div>{{model.name | date:'yyyy-MM-dd HH:mm'}}</div>
                    </ng-template>
                </ngx-charts-line-chart>
            </div>
            <div *ngIf="eventsPerSecInfo()?.length === 0" class="loading-container">
                <div class="loader"></div>
            </div>
        </div>
        <div class="grid-item full" id="audit-records">
            <div class="header">
                <h3>Audit information</h3>
            </div>
            <div class="chart overflow-auto ">
                <zf-audit-info *ngIf="!!deployment()" [accountId]="account.accountId"
                    [serialNumber]="deployment().serialNumber"></zf-audit-info>
            </div>
        </div>
        <div class="grid-item small" id="online-storage">
            <div class="header">
                <h3>Online Storage</h3>
            </div>
            <div #onlinePieChart class="chart" *ngIf="deployment()?.entitlement?.onlineStorage.quantity !== 0">
                <ngx-charts-pie-chart [view]="[(onlinePieChart.offsetWidth - 5), (onlinePieChart.offsetHeight - 33)]"
                    [animations]="false" [legend]="true" [legendPosition]="LegendPosition.Below" [legendTitle]="''"
                    [results]="onlineStorageInfo()">
                    <ng-template #tooltipTemplate let-model="model">
                        <span>{{model.name}}</span>
                    </ng-template>
                </ngx-charts-pie-chart>
            </div>
            <div class="error" *ngIf="deployment()?.entitlement?.onlineStorage.quantity === 0"><span>No online storage
                    available</span>
            </div>
        </div>
        <div class="grid-item xlarge" id="storage-information">
            <div class="header">
                <h3>Online event Storage by day</h3>
                <div class="buttons tabs">
                    <button class="highlight" (click)="onlineStorageView.set('table')"
                        [ngClass]="{'active': onlineStorageView() === 'table'}">
                        Table </button>
                    <button class="highlight" (click)="onlineStorageView.set('chart')"
                        [ngClass]="{'active': onlineStorageView() === 'chart'}">
                        Chart
                    </button>
                </div>
            </div>

            <div #onlineChart class="chart" *ngIf="onlineStorageMetrics() && onlineStorageMetrics().length !== 0"
                [ngClass]="{'overflow-auto': onlineStorageView() === 'table'}">
                <ng-container *ngIf="onlineStorageView() === 'chart'">
                    <zf-vertical-bar [data]="onlineStorageMetrics()"></zf-vertical-bar>
                </ng-container>
                <ng-container *ngIf="onlineStorageView() === 'table'">
                    <table class="info stretched">
                        <thead>
                            <tr class="bordered-bottom sticky">
                                <th>Day</th>
                                <th>storage used</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let sim of onlineStorageMetrics(); let i = index" class="dashed-border-bottom">
                                <td>{{ sim.name | date:'yyyy-MM-dd':'UTC' }}</td>
                                <td>{{ sim.series[0].value | diskSize:2 }} </td>
                            </tr>
                        </tbody>
                    </table>
                </ng-container>
            </div>

            <div class="error" *ngIf="onlineStorageMetrics() && onlineStorageMetrics().length === 0">
                <span>No online storage data is currently available.</span>
            </div>

            <div *ngIf="!onlineStorageMetrics()" class="loading-container">
                <div class="loader"></div>
            </div>
        </div>
        <div class="grid-item small" id="archive-storage"
            *ngIf="deployment()?.entitlement?.archiveStorage.quantity !== 0">
            <div class="header">
                <h3>Archive Storage</h3>
            </div>
            <div #archivePieChart class="chart" *ngIf="deployment()?.entitlement?.archiveStorage.quantity !== 0">
                <ngx-charts-pie-chart [view]="[archivePieChart.offsetWidth, (archivePieChart.offsetHeight - 33)]"
                    [animations]="false" [legend]="true" [legendPosition]="LegendPosition.Below" [legendTitle]="''"
                    [results]="archiveStorageInfo()">
                    <ng-template #tooltipTemplate let-model="model">
                        <span>{{model.name}}</span>
                    </ng-template>
                </ngx-charts-pie-chart>
            </div>
            <div class="error" *ngIf="deployment()?.entitlement?.archiveStorage.quantity === 0"><span>No archive storage
                    available</span>
            </div>
        </div>
        <div class="grid-item xlarge" id="storage-information"
            *ngIf="deployment()?.entitlement?.archiveStorage.quantity !== 0">
            <div class="header">
                <h3>Archive event Storage by day</h3>
                <div class="buttons tabs">
                    <button class="highlight" (click)="archiveStorageView.set('table')"
                        [ngClass]="{'active': archiveStorageView() === 'table'}">
                        Table </button>
                    <button class="highlight" (click)="archiveStorageView.set('chart')"
                        [ngClass]="{'active': archiveStorageView() === 'chart'}">
                        Chart
                    </button>
                </div>
            </div>

            <div #archiveChart class="chart" *ngIf="archiveStorageMetrics() && archiveStorageMetrics().length !== 0"
                [ngClass]="{'overflow-auto': archiveStorageView() === 'table'}">
                <ng-container *ngIf="archiveStorageView() === 'chart'">
                    <zf-vertical-bar [data]="archiveStorageMetrics()"></zf-vertical-bar>
                </ng-container>
                <ng-container *ngIf="archiveStorageView() === 'table'">
                    <table class="info stretched">
                        <thead>
                            <tr class="bordered-bottom sticky">
                                <th>Day</th>
                                <th>storage used</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let sim of archiveStorageMetrics(); let i = index" class="dashed-border-bottom">
                                <td>{{ sim.name | date:'yyyy-MM-dd':'UTC' }}</td>
                                <td>{{ sim.series[0].value | diskSize:2 }} </td>
                            </tr>
                        </tbody>
                    </table>
                </ng-container>
            </div>

            <div class="error" *ngIf="archiveStorageMetrics() && archiveStorageMetrics().length === 0">
                <span>No archive storage data is available currently.</span>
            </div>

            <div *ngIf="!archiveStorageMetrics()" class="loading-container">
                <div class="loader"></div>
            </div>
        </div>
        <div class="grid-item xlarge overflow-visible" id="external-storage-details">
            <div class="header">
                <div>
                    <h3>External Storage</h3>
                    <span class="info" [ngClass]="{'highlight': storageInfoView()}"
                        (click)="storageInfoView.set(!storageInfoView())">INFO</span>
                </div>
                <div class="buttons tabs">
                    <button class="no-highlight" (click)="storage()">New</button>
                    <button class="no-highlight" [disabled]="!selectedSto()"
                        (click)="storage(selectedSto().id)">Edit</button>
                    <button class="danger no-highlight" [disabled]="!selectedSto()"
                        (click)="storage(selectedSto().id, true)">Delete</button>
                </div>
            </div>

            <div class="chart overflow-auto"
                *ngIf="!storageInfoView() && (!externalStorageLoading() && extStorages()?.length !== 0)">
                <table class="info stretched">
                    <thead>
                        <tr class="bordered-bottom sticky">
                            <th>Organization ID</th>
                            <th class="wide">Destination</th>
                            <th></th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let sto of extStorages(); let i = index" (click)="selectStorage(sto)"
                            class="dashed-border-bottom" [ngClass]="{
                            'highlighted': sto?.id === selectedSto()?.id
                            }">
                            <td>{{ sto.organizationId | orgId }}</td>
                            <td>{{ sto.externalStorageDest }}</td>
                            <td *ngIf="!sto.lastUpdate && !sto.lastStatus">No transfer of data to this external storage
                                has taken place yet</td>
                            <td *ngIf="!!sto.lastStatus && sto.lastStatus === 'InProgress'">Started transfer on {{
                                sto.lastUpdate | date:'medium' }}</td>
                            <td *ngIf="!!sto.lastStatus && sto.lastStatus === 'Complete'">
                                Successfully transferred {{ sto.dataTransferred | diskSize:2 }} on {{ sto.lastUpdate |
                                date:'medium' }}
                            </td>
                            <td *ngIf="!!sto.lastStatus && sto.lastStatus === 'Failed'" class="failed">
                                Failed to transfer data on {{ sto.lastUpdate | date:'medium' }}: <br /> {{ sto.comments
                                }}
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>

            <div class="error" *ngIf="(!externalStorageLoading() && extStorages()?.length === 0) || storageInfoView()">
                <p *ngIf="extStorages()?.length === 0">No external storage locations are currently setup for your
                    FortiSIEM Cloud instance.</p>
                <p>Setting up External storage is simple.</p>
                <p>Click New and provide the following information:</p>
                <ul>
                    <li>An AWS S3 bucket, which resides in the same region as your instance - {{ displayRegion() }}</li>
                    <li>A specific Organization ID, or 'ALL' if you want to store all data</li>
                </ul>
                <p>Once added you need to apply the IAM policy to your bucket which will allow your FortiSIEM Cloud
                    instance to write data to the destination.</p>
            </div>

            <div *ngIf="externalStorageLoading()" class="loading-container">
                <div class="loader"></div>
            </div>
        </div>
    </div>
</div>

<zf-modal *ngIf="changingStorages()" #storageModal [ngClass]="deletingStorage() ? 'medium' : 'large' ">
    <ng-container *ngIf="!deletingStorage()" modal-header>
        <span *ngIf="newStorage()">Setup External Storage Location</span>
        <span *ngIf="!newStorage()">Edit External Storage Location for Organization ID: {{storageDetail().organizationId |
            orgId}}</span>
    </ng-container>
    <ng-container *ngIf="deletingStorage()" modal-header>
        <span *ngIf="deletingStorage()">Delete External Storage</span>
    </ng-container>
    <ng-container *ngIf="deletingStorage()" modal-body>
        <div class="confirmation-icon">
            <span class="danger-alert large-icon">&#9888;</span>
        </div>
        <div class="confirmation-text">
            <p>Are you sure you want to delete the external storage destination <b>{{
                    storageDetail().externalStorageDest}}</b> for Organization ID <b>{{ storageDetail().organizationId
                    | orgId}}</b>?</p>
            <p>Once confirmed this destination cannot be recovered and no new data will be transferred to it.</p>
        </div>
    </ng-container>
    <ng-container *ngIf="!deletingStorage()" modal-body>
        <div class="edit columns">
            <div *ngIf="newStorage()" class="edit-block large"
                [ngClass]="{'error': storageDetail().error.get('organizationId')}">
                <label>Organization ID</label>
                <div class="inline">
                    <input type="checkbox" [checked]="storageDetail().organizationId === -1"
                        (change)="storageDetail().organizationId=all.checked ? -1 : 0" #all />
                    <label for="all">Transfer data from all organizations into a single bucket</label>
                </div>
                <input type="text" [disabled]="all.checked"
                    [ngModel]="storageDetail().organizationId !== -1 ? storageDetail().organizationId : ''"
                    (ngModelChange)="storageDetail().organizationId=$event" name="externalStorageOrgId"
                    placeholder="Add an organization id to transfer only this data" />
                <i *ngIf="!newStorage()" class="help">This value cannot be edited</i>
                <i *ngIf="newStorage()" class="help">Add an organization id to specify which organizations data will purge
                    to this particular
                    bucket.
                    If you want all data to purge to a particular bucket set it to ALL. You cannot change this after you
                    have created an external storage</i>
                <span class="error-text"
                    *ngIf="storageDetail().error.get('organizationId')">{{storageDetail().error.get('organizationId')}}</span>
            </div>
            <div class="edit-block large" [ngClass]="{'error': storageDetail().error.get('externalStorageBucket')}">
                <label>AWS S3 Bucket name</label>
                <input type="text" [(ngModel)]="externalStorageBucket" (change)="updateFullBucket()"
                    name="externalStorageBucket" placeholder="Define an S3 storage bucket to transfer data to" />
                <i class="help">Add an AWS S3 bucket which resides in the same region as your FortiSIEM Cloud instance.
                    Once data has progressed through online and archive, data is transferred automatically to this
                    bucket.</i>
                <i class="help">This bucket must have a prefix of <b>fsiemextstr-</b> in order to have the required
                    permissions to upload to your bucket</i>
                <span class="error-text"
                    *ngIf="storageDetail().error.get('externalStorageBucket')">{{storageDetail().error.get('externalStorageBucket')}}</span>
            </div>
            <div class="edit-block large" [ngClass]="{'error': storageDetail().error.get('externalStorageDirectory')}">
                <label>AWS S3 bucket directory</label>
                <input type="text" [(ngModel)]="externalStorageDirectory" (change)="updateFullBucket()"
                    name="externalStorageDirectory"
                    placeholder="Define any prefixes for the bucket, these are typically directory names" />
                <i class="help">Add a directory to prefix all data going into this bucket. This can be as many folders
                    deep as you need.</i>
                <i class="help">Example: directory_1/directory_2</i>
                <span class="error-text"
                    *ngIf="storageDetail().error.get('externalStorageDirectory')">{{storageDetail().error.get('externalStorageDirectory')}}</span>
            </div>
            <div class="edit-block large">
                <label>AWS S3 Destination</label>
                <input readonly disabled="true" type="text" [ngModel]="storageDetail().externalStorageDest"
                    name="externalStorageDest" />
                <i class="help">The full path which FortiSIEM Cloud will use to move data to once Online and Archive is
                    full.</i>
            </div>
            <div class="edit-block large" (click)="copyToClipboardObject($event, externalStoragePolicy());">
                <label>AWS S3 Policy - click to copy to clipboard</label>
                <textarea readonly class="resizable" [ngModel]="externalStoragePolicy() | json" name="policy"
                    draggable="true"></textarea>
                <i class="help">Apply this policy to the S3 bucket in your AWS Account in the AWS Management Console.
                </i>
                <i class="help">Once applied this will give the required permissions for FortiSIEM Cloud to upload data
                    to your bucket</i>
            </div>
        </div>
    </ng-container>
    <ng-container modal-footer>
        <button *ngIf="deletingStorage()" class="btn danger" (click)="deleteFromStorage($event)">
            <span>Delete</span>
        </button>
        <button *ngIf="!deletingStorage()" class="btn" (click)="addToStorage($event)">
            <span>Add</span>
        </button>
    </ng-container>
</zf-modal>

<zf-modal *ngIf="scheduling()" #scheduleModal class="medium">
    <ng-container modal-header>
        <span>Schedule update to {{ versionUpdate().newVersion }}</span>
    </ng-container>
    <ng-container modal-body>
        <div class="edit">
            <div class="edit-block large">
                <label for="scheduleUpdate">Schedule Update</label>
                <zf-schedule-upgrade [scheduledDate]="scheduledDate()" [minUpdateDate]="minUpdateDate"
                    [maxUpdateDate]="maxUpdateDate"
                    (scheduledDateChange)="updateScheduledDate($event)"></zf-schedule-upgrade>
                <i class="help">
                    Select a day, time, and UTC offset for when you want your upgrade() to occur.
                    Upgrades take approximately 1 hour to fully propagate.
                    During this time access may be intermittent and any local collectors will cache and upload data once
                    the update is complete.
                </i>
            </div>
        </div>
    </ng-container>
    <ng-container modal-footer>
        <button class="btn" (click)="scheduleUpdate($event)">
            <span>Schedule</span>
        </button>
    </ng-container>
</zf-modal>

<zf-modal #editModal *ngIf="editing()" class="medium">
    <ng-container modal-header>
        <div class="tabs">
            <button class="highlight" (click)="editState.set('network')"
                [ngClass]="{'active': editState() === 'network'}">Network</button>
            <button class="highlight" (click)="editState.set('notifications')"
                [ngClass]="{'active': editState() === 'notifications'}">Notifications</button>
            <button class="highlight" (click)="editState.set('domain')"
                [ngClass]="{'active': editState() === 'domain'}">Alternate
                Domain</button>
        </div>
    </ng-container>
    <ng-container *ngIf="editState() === 'confirmation'" modal-body>
        <div class="confirmation-icon">
            <span class="danger-alert large-icon">&#9888;</span>
        </div>
        <div class="confirmation-text">
            <p>Are you sure you want to update <b>{{ deployment()?.serialNumber }}</b> with these changes?</p>
            <p>Once confirmed changes can take time to propagate fully. During this time any new edits will not be
                allowed.</p>
        </div>
    </ng-container>
    <ng-container *ngIf="editState() !== 'confirmation'" modal-body>
        <div *ngIf="editState() === 'network'" class="edit columns">
            <div class="edit-block large" [ngClass]="{'error': activatedStackInfo().error.get('isRandomUrl')}"
                *ngIf="!deployment().information.isRandomUrl">
                <label>Enable Random Urls</label>
                <div class="inline">
                    <input type="checkbox" [(ngModel)]="isRandomUrl" name="isRandomUrl" />
                    <label>Whether to change Super and Worker URLs to Random strings</label>
                </div>
                <i class="help">Enabling this setting will result in connectivity changes lasting several minutes and
                    may require reinstallation of any agents and or collectors.
                    Once changed, it is not possible to revert to the previous FQDN's. </i>
                <i class="help">The following will be the new randomized FQDN's for Super and Worker communications:</i>
                <i class="help"><b>Super FQDN:</b> {{deployment().information.superRandomUrl}}</i>
                <i class="help"><b>Worker FQDN:</b> {{deployment().information.workersRandomUrl}}</i>

                <span class="error-text"
                    *ngIf="activatedStackInfo().error.get('isRandomUrl')">{{activatedStackInfo().error.get('isRandomUrl') |
                    errorText}}</span>
            </div>
            <div class="edit-block" [ngClass]="{'error': activatedStackInfo().error.get('ipv4')}">
                <label>IPV4 list of CIDR blocks</label>
                <textarea type="text" [(ngModel)]="ipV4" name="ipv4CIDRList"></textarea>
                <i class="help">List of IPv4 CIDR blocks from where access is allowed add each entry to a new line.
                    Blocks must be valid IPv4 CIDR ranges</i>
                <i class="help">Example: 10.1.1.1/29 is incorrect, instead enter 10.1.1.0/29</i>
                <span class="error-text" *ngIf="activatedStackInfo().error.get('ipv4')">{{activatedStackInfo().error.get('ipv4') |
                    errorText}}</span>
            </div>
            <div class="edit-block" [ngClass]="{'error': activatedStackInfo().error.get('ipv6')}">
                <label>IPV6 list of CIDR blocks</label>
                <textarea type="text" [(ngModel)]="ipV6" name="ipv6CIDRList"></textarea>
                <i class="help">List of IPv6 CIDR blocks from where access is allowed. Add each entry to a new line.
                    Blocks must be valid IPv6 CIDR ranges</i>
                <i class="help">Example: 2001:db8:85a3::8a2e:370:7336/126 is incorrect, instead enter
                    2001:0db8:85a3:0000:0000:8a2e:0370:7334/126</i>
                <span class="error-text" *ngIf="activatedStackInfo().error.get('ipv6')">{{activatedStackInfo().error.get('ipv6') |
                    errorText}}</span>
            </div>
        </div>
        <div *ngIf="editState() === 'notifications'" class="edit">
            <div class="edit-block" [ngClass]="{'error': activatedStackInfo().error.get('additionalContacts')}">
                <label>Additional Contacts</label>
                <textarea type="text" [(ngModel)]="additionalContacts" name="additionalContacts"></textarea>
                <i class="help">List of additional email addresses such as user&#64;domain.com to receive notifications
                    from
                    FortiSIEM Cloud
                    platform. Add each entry to a new line.</i>
                <span class="error-text"
                    *ngIf="activatedStackInfo().error.get('additionalContacts')">{{activatedStackInfo().error.get('additionalContacts')}}</span>
            </div>
        </div>
        <div *ngIf="editState() === 'domain'" class="edit columns">
            <div class="tabs center">
                <button (click)="certificateState.set('file')"
                    [ngClass]="{'active': certificateState() === 'file'}">File</button>
                <button (click)="certificateState.set('manual')"
                    [ngClass]="{'active': certificateState() === 'manual'}">Manual</button>
            </div>
            <ng-container *ngIf="certificateState() === 'file'">
                <div class="edit-block">
                    <label>Select certificate() file</label>
                    <input type="text" [(ngModel)]="certificateFilePath" name="certificateFilePath"
                        placeholder="Choose a certificate file" />
                    <button class="btn float-in"
                        (click)="certificatePassword.set(''); extractionError.set(''); certificate.set(null); fileChooser.click()">Choose
                        File</button>
                    <input multiple="false" type="file" style="display: none;" accept=".p12"
                        (change)="setCertificate($event)" #fileChooser />
                    <i class="help">
                        Extract information from a local file, supported file types are .p12</i>
                </div>
                <div class="edit-block" [ngClass]="{'error': extractionError()}">
                    <label>Provide password for certificate()</label>
                    <input type="password" [(ngModel)]="certificatePassword" name="certificatePassword"
                        placeholder="Enter certificate password" />
                    <button class="btn float-in" (click)="handleCertificate($event)">Load</button>
                    <i class="help">
                        Enter certificate() password if not used, leave blank.</i>
                    <span class="error-text" *ngIf="extractionError()">{{extractionError()}}</span>
                </div>
                <ng-container *ngIf="!!certificate()">
                    <div class="edit-block separator">
                        <label>Certificate info</label>
                        <i class="help">Certificate information found in {{ certificateFilePath() }}</i>
                    </div>
                    <div class="edit-block">
                        <label>Issued To</label>
                        <div class="table-row">
                            <div class="row">
                                <span class="field">Common Name (CN)</span>
                                <span class="value">{{ certificate().subject.getField('CN')?.value || '-' }} </span>
                            </div>
                            <div class="row">
                                <span class="field">Organization (O)</span>
                                <span class="value">{{ certificate().subject.getField('O')?.value || '-' }}</span>
                            </div>
                            <div class="row">
                                <span class="field">Organization Unit (OU)</span>
                                <span class="value">{{ certificate().subject.getField('OU')?.value || '-' }}</span>
                            </div>
                        </div>

                        <label>Issued By</label>
                        <div class="table-row">
                            <div class="row">
                                <span class="field">Common Name (CN)</span>
                                <span class="value">{{ certificate().issuer.getField('CN')?.value || '-' }}</span>
                            </div>
                            <div class="row">
                                <span class="field">Organization (O)</span>
                                <span class="value">{{ certificate().issuer.getField('O')?.value || '-' }}</span>
                            </div>
                            <div class="row">
                                <span class="field">Organization Unit (OU)</span>
                                <span class="value">{{ certificate().issuer.getField('OU')?.value || '-' }}</span>
                            </div>
                        </div>

                        <label>Validity</label>
                        <div class="table-row">
                            <div class="row">
                                <span class="field">Issued On</span>
                                <span class="value">{{ certificate().validity.notBefore || '-' | date}}</span>
                            </div>
                            <div class="row">
                                <span class="field">Expires On</span>
                                <span class="value">{{ certificate().validity.notAfter || '-' | date}}</span>
                            </div>
                        </div>
                    </div>
                </ng-container>
            </ng-container>
            <ng-container *ngIf="certificateState() === 'manual'">
                <div class="edit-block large" [ngClass]="{'error': activatedStackInfo().error.get('alternateDomain')}">
                    <label>Alternate Domain</label>
                    <input type="text" [(ngModel)]="alternateDomain" name="alternateDomain" />
                    <i class="help">Add an alternate domain to your deployment() in addition to the default
                        {{ deployment().information.url | url }}. Provide the domain, a certificate() body, its private key
                        and
                        the certificate() chain that must be included.</i>
                    <span class="error-text"
                        *ngIf="activatedStackInfo().error.get('alternateDomain')">{{activatedStackInfo().error.get('alternateDomain')}}</span>
                </div>
                <div class="edit-block large"
                    [ngClass]="{'error': activatedStackInfo().error.get('alternatePublicCertificate')}">
                    <label>Certificate Body</label>
                    <textarea type="text" [(ngModel)]="certificateBody" name="certificateBody"
                        placeholder="-----BEGIN CERTIFICATE-----&#10;MIIDtTCCAp2gAwIBAgIUMg9phiffh+H9mKU&#10;BQAwajELMAkGA1UEBhMCVVMxEzARBgNV...&#10;-----END CERTIFICATE-----"></textarea>
                    <i class="help">PEM encoded certificate() body which must be valid.</i>
                    <span class="error-text"
                        *ngIf="activatedStackInfo().error.get('alternatePublicCertificate')">{{activatedStackInfo().error.get('alternatePublicCertificate')}}</span>

                </div>
                <div class="edit-block large"
                    [ngClass]="{'error': activatedStackInfo().error.get('alternatePrivateCertificate')}">
                    <label>Certificate private key</label>
                    <textarea type="text" [(ngModel)]="certificatePrivate" name="certificatePrivate"
                        placeholder="-----BEGIN PRIVATE KEY-----&#10;MIIEvQIBADANBgkqhkiG9w0BAQEFAASCBKc&#10;EHHhBdzWfEX0oqi84Vr5uof7EAmzynQR...&#10;-----END PRIVATE KEY-----"></textarea>
                    <i class="help">PEM encoded certificate() private key. Private key cannot be encrypted, and should not
                        be
                        larger than 5KB (5120 bytes).</i>
                    <span class="error-text"
                        *ngIf="activatedStackInfo().error.get('alternatePrivateCertificate')">{{activatedStackInfo().error.get('alternatePrivateCertificate')}}</span>
                </div>
                <div class="edit-block large"
                    [ngClass]="{'error': activatedStackInfo().error.get('alternateChainCertificate')}">
                    <label>Certificate Chain - <i>Optional</i></label>
                    <textarea type="text" [(ngModel)]="certificateChain" name="certificateChain"
                        placeholder="-----BEGIN CERTIFICATE-----&#10;MIIDtTCCAp2gAwIBAgIUMg9phiffh+H9mKU&#10;BQAwajELMAkGA1UEBhMCVVMxEzARBgNV...&#10;-----END CERTIFICATE-----"></textarea>
                    <i class="help">PEM encoded certificate() chain data include this if your certificate() is signed by a
                        Certificate Authority (CA).</i>
                    <span class="error-text"
                        *ngIf="activatedStackInfo().error.get('alternateChainCertificate')">{{activatedStackInfo().error.get('alternateChainCertificate')}}</span>

                </div>
            </ng-container>
        </div>
    </ng-container>
    <ng-container modal-footer>
        <button *ngIf="editState() !== 'confirmation'" class="danger" (click)="editValidate($event)">
            <span>Update</span>
        </button>
        <button *ngIf="editState() === 'confirmation'" class="btn" (click)="editState.set('network')">
            <span>Edit</span>
        </button>
        <button *ngIf="editState() === 'confirmation'" class="danger" (click)="update(deployment(), $event)">
            <span *ngIf="!updating()">Confirm</span>
            <img *ngIf="updating()" src="assets/icons/loader.gif" width="20" height="20" srcset="assets/icons/loader.gif"
                src-orig="assets/icons/loader.gif">
        </button>
    </ng-container>
</zf-modal>
